export default "__VITE_ASSET__5e5be568__"